import { render, staticRenderFns } from "./MyCustomer.vue?vue&type=template&id=72429c1f&scoped=true&"
import script from "./MyCustomer.vue?vue&type=script&lang=js&"
export * from "./MyCustomer.vue?vue&type=script&lang=js&"
import style0 from "./MyCustomer.vue?vue&type=style&index=0&id=72429c1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72429c1f",
  null
  
)

export default component.exports